import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rk-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
